import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FieldTrackingConfig } from 'src/app/config/eev-form-tracking.config';
import { FieldError } from 'src/app/models/event-data.model';

@Component({
    selector: 'app-create-password-input-field',
    templateUrl: './create-password-input-field.component.html',
    styleUrls: ['./create-password-input-field.component.scss'],
    standalone: false
})
export class CreatePasswordInputFieldComponent {
  @Input() parentForm: UntypedFormGroup;
  @Input() confirmPasswordError: string;
  @Input() passwordTrackingConfig: FieldTrackingConfig
  @Input() confirmTrackingConfig: FieldTrackingConfig
  @Input() errorTrackingSubject: Subject<FieldError>

  hidePassword = true;
  hideReEnterPassword = true;

  getPasswordInputError() {
    if (this.parentForm.get('password').hasError('required')) {
      return 'A password is required to create your account';
    }
  }

  getPasswordMismatchError() {
    if (this.parentForm.get('confirmPassword').hasError('required')) {
      return 'Please re-enter your password';
    }
    if (this.parentForm.get('confirmPassword').hasError('PasswordMismatch')) {
      return 'Your password and confirmation password do not match';
    }
  }
}